<script lang="ts" setup>
import type { PropertySearchCriteria } from '@@/shared/property/search-criteria';

const emit = defineEmits<{
  alert: [PropertySearchCriteria]
}>();

const route = useRoute();
const { propertySearchCriteria } = usePropertySearchCriteria(route);

function onClick() {
  emit('alert', propertySearchCriteria.value);
}
</script>

<template>
  <div class="flex flex-col md:flex-row justify-center gap-xl py-m text-center">
    <figure>
      <img
        loading="lazy"
        src="~/assets/images/empty.jpg"
        class="object-cover md:h-52 md:rounded-md"
      >
    </figure>
    <div class="content-center gap-xl">
      <div class="md:text-left">
        <IadTitle
          tag="p"
          :text="$t(`property_serp.no_ad_found`)"
        />
        <IadTitle
          tag="p"
          variant="x-small"
          :text="$t(`property_serp.no_ad_create_alert`)"
        />
      </div>
      <IadBtn
        variant="filled"
        class="mt-l"
        @click="onClick"
      >
        <Icon name="iad-icon:notifications" />
        {{ $t(`property_serp.notification.create_alert`) }}
      </IadBtn>
    </div>
  </div>
</template>
